"use client";

import { createContext, useContext, type ReactNode } from "react";

export type VariantPayloads = Record<
  string,
  Record<string, string> | null
>;

const VariantsContext = createContext<VariantPayloads>({});

export function VariantsProvider({
  variants,
  children,
}: Readonly<{
  variants: VariantPayloads;
  children: ReactNode;
}>) {
  return (
    <VariantsContext.Provider value={variants}>{children}</VariantsContext.Provider>
  );
}

export function useVariantPayload(
  key: string,
): Record<string, string> | null {
  const variants = useContext(VariantsContext);
  return variants[key] ?? null;
}
